module.exports = __webpack_public_path__ + "img/map_merida.630a03bc.png";